import React from 'react';

import { Icon } from '../icons';

export const ArrowRightIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 16 16" fill={color} style={style}>
      <path d="M6.80281 1.05195L7.59558 0.253547C7.93126 -0.0845156 8.47405 -0.0845156 8.80616 0.253547L15.7482 7.24137C16.0839 7.57943 16.0839 8.12609 15.7482 8.46055L8.80616 15.452C8.47048 15.79 7.92769 15.79 7.59558 15.452L6.80281 14.6536C6.46356 14.3119 6.47071 13.7545 6.8171 13.42L11.1202 9.29132H0.857047C0.3821 9.29132 0 8.90651 0 8.42819V7.27734C0 6.79901 0.3821 6.4142 0.857047 6.4142H11.1202L6.8171 2.28552C6.46714 1.95105 6.45999 1.39361 6.80281 1.05195Z" />
    </svg>
  );
};
